<template>
  <div class="checkout-bonuses">
    <h4 class="checkout-bonuses__title">
      Клубная программа
      <info-block
        is-interactive
        :tooltip-text="clubProgrammTooltipText"
      />
    </h4>
    <template v-if="LOGGED_IN">
      <ui-checkbox
        :value="isApplied"
        :label="useBonusesText"
        @input="changeBonusesState"
      />
    </template>
    <p v-else>
      <span class="link-blue" @click="login">Авторизуйтесь</span> для начисления и использования бонусов.
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import InfoBlock from '@kit/info-block/info-block.vue';
import { debounce } from 'throttle-debounce';

export default {
  name: 'checkout-bonuses',

  components: { InfoBlock },

  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
      ACCOUNT: 'user/account',
      BONUSES: 'cart/bonuses',
      USER_BONUSES: 'user/bonuses',
    }),
    clubProgrammTooltipText() {
      return `Позволяет накапливать бонусы при покупке товаров и оплачивать ими до 30% следующих заказов.
      <a href="/checkout" target="_blank">Подробнее</a>`;
    },
    useBonusesText() {
      return `Использовать баллы, доступно ${this.$options.filters.price(this.USER_BONUSES)}`;
    },
    isApplied() {
      return !!this.BONUSES?.applied;
    },
  },

  created() {
    if (this.$isServer) return;
    this.ENABLE_USE_BONUSES();
  },

  methods: {
    ...mapActions({
      APPLY_BONUSES: 'cart/applyBonuses',
      ENABLE_USE_BONUSES: 'cart/enableUseBonuses',
    }),
    ...mapMutations('cart', ['setProgress']),
    login() {
      this.$f.login().catch(() => {});
    },
    debouncedApplyBonuses: debounce(300, function(isApplied) {
      this.APPLY_BONUSES(isApplied);
    }),
    changeBonusesState(isApplied) {
      this.setProgress();
      this.debouncedApplyBonuses(isApplied);
    },
  },
}
</script>

<style lang="scss">
.checkout-bonuses {
  p {
    font-size: 12px;
    line-height: 16px;
  }

  .info-block {
    vertical-align: middle;
    font-weight: normal;
  }
}

@include breakpoint("desktop") {
  .checkout-bonuses {
    p {
      font-size: 14px;
    }
  }
}
</style>
